import { asNumber, asString, asStringArray } from '../http/normalise';
import { ApiEvent } from './event.dto';
import { Event, EventStatus } from './event.model';
import { Locale, asLocale } from './role.model';

const DEFAULT_TIMEZONE = 'Europe/Amsterdam';
const DEFAULT_LANGUAGES: ReadonlyArray<Locale> = ['en'];

function asEventStatus(value: unknown): EventStatus {
  return value === 'published' ? 'published' : 'draft';
}

function asLocales(value: unknown): ReadonlyArray<Locale> {
  const locales = asStringArray(value)
    .map(asLocale)
    .filter((locale): locale is Locale => locale !== null);

  return locales.length > 0 ? locales : DEFAULT_LANGUAGES;
}

export function mapEvent(dto: ApiEvent): Event {
  return {
    id: asString(dto.id) ?? '',
    clientId: asString(dto.clientId) ?? '',
    name: asString(dto.name) ?? '',
    slug: asString(dto.slug) ?? '',
    startDate: asString(dto.startDate) ?? '',
    endDate: asString(dto.endDate) ?? asString(dto.startDate) ?? '',
    timezone: asString(dto.timezone) ?? DEFAULT_TIMEZONE,
    venueName: asString(dto.venueName),
    venueAddress: asString(dto.venueAddress),
    capacity: asNumber(dto.capacity),
    languages: asLocales(dto.languages),
    description: asString(dto.description),
    registrationOpensAt: asString(dto.registrationOpensAt),
    registrationClosesAt: asString(dto.registrationClosesAt),
    status: asEventStatus(dto.status),
    capacityAlertThreshold: asNumber(dto.capacityAlertThreshold),
  };
}
